<div class="feedback-smiley-container">

  <img class="smileys" src="./assets/images/smileys.png" alt="smileys">
  <div class="blue-text fb-title">{{getString('feedbackTitle')}}</div>
  <div class="fb-text">{{getString('feedbackText1')}}</div>
  <div class="fb-text">{{getString('feedbackText2')}}</div>
  <button type="button" class="blue-button" (click)="contact()">{{getString('contactUs')}}</button>

</div>

<app-modal #feedbackModal [title]="getString('contactUs')">
  <app-feedback-form></app-feedback-form>
</app-modal>